import React, { useRef, useEffect, useState } from "react";
import { message, Spin, Modal } from "antd";
import { ICardFormFields, cardService, ICardDetail, ICardInsert, ICardUpdate } from "../cardService";
import { useCardModel } from "../cardModel";
import { IYhFormRef, FormItemTypeEnum, IYhForm, ISelectOption } from "@/components/YhFormBox/Types";
import { forFind, getByteLen, getFormValidatorErrText } from "@/utils/utils";
import { YHDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import useGlobalModel from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import headIcon from "../../../assets/head-icon.png";
import cancel from "../../../assets/cancel.png";

interface ILoadingType {
    visible: boolean,
    txt: string
}
export function DetailDrawer() {
    const { fetchCompanyList, fetchBusinessList, orgDs } = useGlobalModel();
    const { cardDrawer: { visible, mode }, setICardDrawer, getSelectedRowData, loadData } = useCardModel();
    const formRef = useRef<IYhFormRef>();
    const { ebcBusinessDto, ebcCompanyDto, userEntityId, ...formVal } = getSelectedRowData();
    const [dataSource, setDataSource] = useState<ICardDetail[]>([]);  //该用户所有身份
    const [selectFormVal, setSelectFormVal] = useState<ICardDetail | null>({}); //当前选中得身份
    const [loading, setLoading] = useState<ILoadingType>({ visible: false, txt: "" });

    useEffect(() => {
        if (visible) {
            getCardByIdList()
        } else {
            loadData()
        }
    }, [visible]);

    const onCancel = () => {
        setICardDrawer();
    }

    //获取用户所有身份
    const getCardByIdList = async () => {
        setLoading({ visible: true, txt: "数据请求中..." })
        try {
            let { retData } = await cardService.getCardById(userEntityId as string);
            setDataSource(retData ?? []);
            setSelectFormVal(retData?.find(item => item.current === "1") ?? null)
            setLoading({ visible: false, txt: "数据请求中..." })
        } catch {
            setLoading({ visible: false, txt: "数据请求中..." })
        }
    }

    //选中身份
    const selectCurrent = async (obj: ICardDetail) => {
        let { retData } = await cardService.updateCurrent(obj.id as string);
        getCardByIdList();
        message.success("切换身份成功");
    }

    //创建新名片
    const addCard = () => {
        if (selectFormVal && !selectFormVal.id) {
            message.warning("当前新名片还未保存！！！")
            return;
        }
        let newObj: ICardDetail = {
            position: "默认身份",
            current: "1"
        };
        setDataSource(origin => [...origin.map(item => ({ ...item, current: "0" })), newObj]);
        formRef.current?.resetFields()
        setSelectFormVal(newObj);
    };
    //添加新名片
    const insertCard = async (obj: ICardInsert) => {
        let { retData } = await cardService.insert(obj);
        let { retData: currentRet } = await cardService.updateCurrent(retData as string);
        getCardByIdList()
        message.success("新增成功");
    }
    //编辑名片
    const editCard = async (val: ICardUpdate) => {
        let { ebcBusinessDto, ebcCompanyDto, updateTime, createTime, ...params } = val;
        let { retData } = await cardService.update(params);
        message.success("业务配置成功");
    }
    //删除名片
    const deleteCard = async (obj: ICardDetail) => {
        if (!obj.id) {
            getCardByIdList();
            return;
        }
        if (obj.id === selectFormVal?.id) {
            message.warning("请切换身份后进行删除");
            return;
        }
        Modal.confirm({
            title: '删除名片',
            content: `确认删除此【${obj.name}】名片`,
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                let { retData } = await cardService.delete(obj.id ?? "");
                getCardByIdList();
                message.success("删除成功");
            },
            onCancel: () => { }
        })
    };
    /**
     * 表单提交
     * 【名片展示区域】姓名限定≤16个字段；职位限定≤24个字段；公司名称限定≤54个字段；地址限定≤80个字段
     */
    const onSubmit = async () => {
        formRef.current?.validateFields().then((val: ICardFormFields) => {
            if (val.isNameEn === "1") {
                if (!val.nameEn) {
                    return message.warning("请输入你要展示的英文名称");
                }
                // if (getByteLen(val.nameEn) >= 17) {
                //     return message.warning("名称的长度不能大于16位");
                // }
            }
            // if(getByteLen(val.position) >= 25){
            //     return message.warning("职位的长度不能大于24位");
            // }
            // if(getByteLen(val.address) >= 71){
            //     return message.warning("地址的长度不能大于70位");
            // }
            // if(getByteLen(val.company) >= 55){
            //     return message.warning("公司的长度不能大于54位");
            // }
            let data = {
                ...val,
                // company: formVal.cardType === DictCodeEnmu.CORD_TYPE_STAFF ? val.company : formVal.company,  //内部员工自动配置公司介绍的名称
                // company: val.company,  //内部员工自动配置公司介绍的名称
                icon: typeof val.icon === "string" ? val.icon : val?.icon?.join(),
                logo: typeof val.logo === "string" ? val.logo : val?.logo?.join(),
                brandPicture: typeof val.brandPicture === "string" ? val.brandPicture : val?.brandPicture?.join(),
                orgName: forFind(orgDs ?? [], val.orgCode as string, "value")?.title ?? val.orgName ?? "",
            }
            if (selectFormVal?.id) {
                editCard({
                    ...selectFormVal,
                    ...data,
                    id: selectFormVal.id
                })
            } else {
                insertCard({
                    ...data,
                    init: "0",
                    name: formVal.name,
                    userEntityId
                })
            }

        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }



    //公司介绍
    const companyChang = (value: string, option: ISelectOption) => {
        // // debugger;
        option && formRef.current?.setFieldsValue({ company: option.label });
    }
    //业务介绍
    const businessChang = (value: string, option: ISelectOption) => {
        // // debugger;
        // option && formRef.current?.setFieldsValue({ currencyName: option.label });
    }

    //图片变更缓存保留  保留缓存及回显表单
    const onSetFieldsValue = (formValues: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(formValues);
    }

    const formConfig: IYhForm<ICardFormFields> = {
        formRef,
        labelCol: { span: 3 },
        formValues: selectFormVal,
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "英文名称",
                fieldName: "nameEn",
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "是否英文名称",
                fieldName: "isNameEn",
                options: [{ label: "是", value: "1" }, { label: "否", value: "0" }],
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入职位" }]
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "职位",
                fieldName: "position",
                placeholder: "职位",
                rules: [{ required: true, message: "请输入职位" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "电话1",
                fieldName: "phone1",
                span: 24,
                placeholder: "电话1",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "微信号",
                fieldName: "wechat",
                span: 24,
                placeholder: "微信号",
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "邮箱",
                fieldName: "email",
                placeholder: "邮箱",
                rules: [{ required: true, message: "请输入邮箱" }]
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "管理公司",
                fieldName: "orgCode",
                span: 24,
                rules: [
                    { required: true, message: "管理公司" }
                ],
                treeData: orgDs
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "部门",
                fieldName: "depName",
                placeholder: "部门",
                // rules: [{ required: true, message: "请输入门店类型" }] 
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "地址",
                fieldName: "address",
                placeholder: "地址",
                // rules: [{ required: true, message: "请输入门店类型" }]
            },
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "网址",
                fieldName: "website",
                placeholder: "网址",
            },
            {
                type: FormItemTypeEnum.Select,
                span: 24,
                fieldLabel: "样式",
                fieldName: "style",
                placeholder: "样式",
                options: [{ label: "A", value: "A" }, { label: "B", value: "B" }],
                rules: [{ required: true, message: "请选择样式" }]
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "公司名称",
                fieldName: "companyProfiles",
                span: 24,
                onSelectChange: companyChang,
                selectfetchList: fetchCompanyList,
                rules: [{ required: true, message: "请选择公司" }],
                defaultQuery: selectFormVal?.ebcCompanyDto?.name
            },
            {
                type: FormItemTypeEnum.AsyncSelect,
                fieldLabel: "业务名称",
                fieldName: "businessProfiles",
                span: 24,
                onSelectChange: businessChang,
                selectfetchList: fetchBusinessList,
                rules: [{ required: true, message: "请选择业务" }],
                defaultQuery: selectFormVal?.ebcBusinessDto?.name
            },
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "用户头像",
                fieldName: "icon",
                span: 24,
                md5List: selectFormVal?.icon ? [selectFormVal?.icon as string] : [],
                onSetFieldsValue,
                photoNum: 1
            },
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "logo",
                fieldName: "logo",
                span: 24,
                md5List: selectFormVal?.logo ? [selectFormVal.logo as string] : [],
                onSetFieldsValue,
                photoNum: 1
            },
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "品牌图片",
                fieldName: "brandPicture",
                span: 24,
                md5List: selectFormVal?.brandPicture ? [selectFormVal.brandPicture as string] : [],
                onSetFieldsValue,
                photoNum: 1
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "公司",
                fieldName: "company",
                hidden: true
            },
        ]
    };
    return (
        <YHDrawer
            {...{
                title: `业务配置`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit,
                headBtnName: "创建新名片",
                onHeadBtn: addCard,
                width: 780
            }}
        >
            <Spin tip={loading.txt} spinning={loading.visible}>

                <div className="position-warp">
                    <div className="title">身份:</div>
                    <div className="position-list">
                        {dataSource && dataSource.map((item, index) => (
                            <div key={item.id ?? index} className={item.current === "1" ? "active" : ""} onClick={() => selectCurrent(item)}>
                                <img src={headIcon} alt="" className="head-img" />
                                <span>{item.position}</span>
                                <img src={cancel} alt="" className="cancel-img" onClick={(e) => { e.stopPropagation(); deleteCard(item) }} />
                            </div>
                        ))}
                    </div>
                </div>
                <div hidden={!selectFormVal}>
                    <YhForm {...formConfig} />
                </div>
            </Spin>
        </YHDrawer>

    )
}
